import React from "react";
import SearchBar from "./SearchBar";

const FilterSection = ({
  title,
  options,
  selected,
  onChange,
  multiSelect = false,
  optionValueKey = null,
  optionLabelKey = null,
  search,
  handleSearchChange,
  customContent
}) => {
  // Handle rendering options that come from API where we need to extract values and labels
  const renderOption = (option) => {
    if (
      typeof option === "object" &&
      option !== null &&
      optionValueKey &&
      optionLabelKey
    ) {
      return option[optionLabelKey];
    }
    return option;
  };

  // Get the option value
  const getOptionValue = (option) => {
    if (typeof option === "object" && option !== null && optionValueKey) {
      return option[optionValueKey];
    }
    return option;
  };

  // Check if an option is selected
  const isSelected = (option) => {
    const optionValue = getOptionValue(option);
    return multiSelect
      ? Array.isArray(selected) && selected.includes(optionValue)
      : selected === optionValue;
  };

  // Handle option click
  const handleOptionClick = (option) => {
    const optionValue = getOptionValue(option);

    if (multiSelect) {
      if (Array.isArray(selected)) {
        if (selected.includes(optionValue)) {
          onChange(selected.filter((item) => item !== optionValue));
        } else {
          onChange([...selected, optionValue]);
        }
      } else {
        onChange([optionValue]);
      }
    } else {
      if (selected === optionValue) {
        onChange(null);
      } else {
        onChange(optionValue);
      }
    }
  };

  return (
    <div className="space-y-2 border-b-[0.5px] border-[#6561611a] p-4 !pt-0">
      <p className="font-[600] text-[14px] font-poppins text-[#303030]">
        {title}
      </p>
      
      {search !== undefined && (
        <SearchBar
          parentDivClass="w-full"
          divClassName="relative"
          inputClassName="searchBar w-full p-3 text-[14px] font-poppins font-[400] outline-none"
          iconClassName="absolute sm:right-[5%] sm:bottom-[30%] lg:right-[3%]"
          placeholder="Search"
          value={search}
          handleChange={(e) => handleSearchChange(e.target.value)}
        />
      )}

      <div className="flex gap-2 flex-wrap">
        {options && options.length > 0 ? (
          options.map((option, index) => {
            const isOptionSelected = isSelected(option);
            const optionLabel = renderOption(option);
            
            return (
              <button
                key={index}
                onClick={() => handleOptionClick(option)}
                className={`px-3 h-[28px] rounded-full text-[13px] font-[500] font-poppins ${isOptionSelected
                  ? "bg-[#00ADEF] text-white"
                  : "bg-[#E5E5E5] text-[#8C8C8C]"
                }`}
              >
                {optionLabel}
              </button>
            );
          })
        ) : options !== undefined ? (
          <span className="text-[#8C8C8C] text-[13px] font-poppins">
            {title === "Subcategory" ? "No Category selected" : "No options available"}
          </span>
        ) : null}
      </div>
      
      {/* Render custom content if provided */}
      <div className="mt-2" style={{ pointerEvents: 'auto', zIndex: 9999 }}>
        {typeof customContent === 'function' ? customContent(selected) : customContent}
      </div>
    </div>
  );
};

export default FilterSection;
